
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useProfile } from "@/hooks/useProfile";
import { useClassDeletion } from "./useClassDeletion";
import { useClassMutation } from "./useClassMutation";
import { ClassFormData, ClassItem } from "./types";

export const useClassManagement = (gymId?: string) => {
  const { profile } = useProfile();

  const { data: classes, refetch } = useQuery({
    queryKey: ["classes", gymId],
    queryFn: async () => {
      console.log("Fetching classes for gymId:", gymId);
      const query = supabase
        .from("classes")
        .select("*")
        .order("created_at", { ascending: false });

      if (profile?.role === 'manager') {
        // For managers, we don't filter here since they might manage multiple gyms
        // The RLS policies will handle the filtering
      } else if (gymId) {
        query.eq('gym_id', gymId);
      }

      const { data, error } = await query;

      if (error) {
        console.error("Error fetching classes:", error);
        throw error;
      }
      
      console.log("Fetched classes:", data);
      return data as ClassItem[];
    },
  });

  const { deletedClasses, handleDelete } = useClassDeletion(refetch);
  const { handleSubmit } = useClassMutation(refetch);

  // Filter out temporarily deleted classes
  const filteredClasses = classes?.filter(classItem => !deletedClasses[classItem.id]);

  return {
    classes: filteredClasses,
    handleSubmit,
    handleDelete: (id: string) => {
      const classToDelete = classes?.find(c => c.id === id);
      if (!classToDelete) {
        console.error("No se encontró la clase con ID:", id);
        return false;
      }
      return handleDelete(id, classToDelete.title);
    },
  };
};

// Re-export the types for convenience
export type { ClassFormData, ClassItem } from "./types";
